module.exports = __webpack_public_path__ + "img/744.6baf7a24.jpg";